export default __webpack_public_path__ + "static/media/RedSeaVilla.20b57143.jpg";